import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { cn } from "@btnet/utilities-core";

import SVG from "commonComponents/btWrappers/BTIcon/images/Takeoffs.svg?react";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";

export const BTIconTakeoffs: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useBaseIcon(baseProps);

    return (
        // eslint-disable-next-line react/forbid-elements
        <Icon {...props} component={SVG} className={cn(props.className)} />
    );
};
